import React, { useEffect, useState } from "react";

import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function EditPerformanceData() {
  const {  perform_id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fiscal_year: "",
    tot_inst_capacity: "",
    hydro_mw: "",
    coal_mw: "",
    gas_mw: "",
    solar_mw: "",
    renewable_mw: "",
    hydro_mu: "",
    coal_mu: "",
    gas_mu: "",
    tot_gen_mu: "",
    non_conventional: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");

  // ----------------------------
  // FETCH EXISTING DATA
  // ----------------------------
  useEffect(() => {
    axios
      .get(`https://backend-zkgn.onrender.com/api/powergen_performance/performance/${perform_id}`)
      .then((res) => {
        setFormData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching performance:", err);
        setLoading(false);
      });
  }, [perform_id]);

  // ----------------------------
  // HANDLE INPUT
  // ----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ----------------------------
  // VALIDATE FORM
  // ----------------------------
  const validate = () => {
    const temp = {};
    let valid = true;

    Object.entries(formData).forEach(([key, val]) => {
      if (!val || val.toString().trim() === "") {
        temp[key] = `${key.replace(/_/g, " ")} is required`;
        valid = false;
      } else if (key !== "fiscal_year" && isNaN(val)) {
        temp[key] = `Enter numeric value`;
        valid = false;
      }
    });

    setErrors(temp);
    return valid;
  };

  // ----------------------------
  // SUBMIT UPDATE REQUEST
  // ----------------------------
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    axios
      .put(
        `https://backend-zkgn.onrender.com/api/powergen_performance/${perform_id}`,
        formData
      )
      .then(() => {
        setSuccessMessage("Performance updated successfully!");
        setTimeout(() => {
            navigate(-1); 
        }, 3000);
      })
      .catch((err) => {
        console.error("Update Failed:", err);
        alert("Update failed. Check console.");
      });
  };

  // ----------------------------
  // LOADING STATE
  // ----------------------------
  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <div className="container my-4">
      <h3 className="text-center mb-4">Edit Power Plant Performance</h3>

      {successMessage && (
        <div className="alert alert-success text-center">{successMessage}</div>
      )}

      <form className="shadow p-4 bg-light rounded" onSubmit={handleSubmit}>
        <div className="row g-3">
          {[
            ["fiscal_year", "Fiscal Year"],
            ["tot_inst_capacity", "Total Installed Capacity (MW)"],
            ["hydro_mw", "Hydro MW"],
            ["coal_mw", "Coal MW"],
            ["gas_mw", "Gas MW"],
            ["solar_mw", "Solar MW"],
            ["renewable_mw", "Renewable MW"],
            ["hydro_mu", "Hydro MU"],
            ["coal_mu", "Coal MU"],
            ["gas_mu", "Gas MU"],
            ["tot_gen_mu", "Total Generated MU"],
            ["non_conventional", "Non-Conventional Energy"],
          ].map(([key, label]) => (
            <div key={key} className="col-md-6">
              <label className="form-label">{label}</label>
              <input
                type="text"
                className={`form-control ${
                  errors[key] ? "is-invalid" : ""
                }`}
                name={key}
                value={formData[key] || ""}
                onChange={handleChange}
              />
              {errors[key] && (
                <small className="text-danger">{errors[key]}</small>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-primary px-4">Update Performance</button>
        </div>
      </form>
    </div>
  );
}

export default EditPerformanceData;
